import gql from 'graphql-tag'
import { MONTHLY_PAYROLL_DATA, EMPLOYEE_DATA, MONTHLY_PAYROLL_ITEM } from './data'
import { PAGINATION_DATA } from '../paginationData'

export const GET_ALL_MONTHLY_PAYROLL_WITH_PAGINATION = gql`
  query  getAllMonthlyPayroll($perPage: Int!, $page: Int!) {
     getAllMonthlyPayroll(first: $perPage, page: $page) {
      ${PAGINATION_DATA}
      data {
        ${MONTHLY_PAYROLL_DATA}
      }
     }
  }
`

export const GET_MONTHLY_PAYROLL = gql`
  query getMonthlyPayroll($month: Int!, $year: Int!) {
    getMonthlyPayroll(month: $month, year: $year) {
      ${MONTHLY_PAYROLL_DATA}
    }
  }
`
export const GET_ITEMS_BY_MONTHLY_PAYROLL = gql`
  query getItemsByMonthlyPayroll($id: ID!) {
    getItemsByMonthlyPayroll(id: $id) {
      employee {
        ${EMPLOYEE_DATA}
      }
      ${MONTHLY_PAYROLL_ITEM}
    }
  }
`
